import React from "react";
import Layout from "../Layout";
import Form from "./form";
import queryString from "query-string";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

function InformationUrls(props) {
  const { request } = useApi();
  const auth = useAuth();
  const { copyId } = queryString.parse(props.location.search);
  const stateError = useError();
  const messages = message();
  const [informationUrl, setInformationUrl] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - ヘッダー告知登録";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }

    if (copyId != null && copyId != "null" ) {
      fetchInformationUrl();
    }
  }, [auth.state.token]);

  const fetchInformationUrl = () => {
    request({
      method: "GET",
      url: `admin/information_urls/${copyId}`,
    }).then((result) => {
      const data = {
        validFrom: result.data.data.valid_from ? 
                    dayjs(result.data.data.valid_from).format("YYYY-MM-DD 00:00:00") : null,
        validUntil: result.data.data.valid_until ? 
                      dayjs(result.data.data.valid_until).format("YYYY-MM-DD 00:00:00") : null,
        title: result.data.data.title,
        desc: result.data.data.desc,
        url: result.data.data.url,
        tId: result.data.data.t_id,
        bfEnv: result.data.data.bf_env,
        params: result.data.data.params,
      }

      setInformationUrl(data);
    });
  }

  const handleSubmit = (formData) => {
    // クエリパラメータをオブジェクト化
    let params = {};
    (formData.inputParams).forEach(inputParam => {
      if (inputParam[0] && inputParam[0] != null &&
            inputParam[1] && inputParam[1] != null) {
              params[inputParam[0]] = inputParam[1];
      }
    })
    
    request({
      method: "POST",
      url: `admin/information_urls`,
      data: {
        valid_from: formData.validFrom,
        valid_until: formData.validUntil,
        title: formData.title,
        desc: formData.desc,
        url: formData.url,
        t_id: formData.tId,
        bf_env: formData.bfEnv,
        params: params,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/InformationUrls?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  // Update 2024.03.31 isEdit追加で複製・新規と更新を切り分ける
  return (
    <Layout
      content={
        <Form
          informationUrl={informationUrl}
          submit={handleSubmit}
          isEdit={false}
        />
      }
    />
  );
}
export default withRouter(InformationUrls);
